export default __webpack_public_path__ + "static/6-8f01def62fd29cbc6ce95ed619f40dd4.jpg";